import HeroSection from './HeroSection';
import TeamsOverviewSection from './TeamsOverviewSection';
import CompetitionShowcaseSection from './CompetitionShowcaseSection';
import DesignNotebooksSection from './DesignNotebooksSection';
import PhotographyGallerySection from './PhotographyGallerySection';
import ImpactTimelineSection from './ImpactTimelineSection';

const Robotics = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <TeamsOverviewSection />
      <CompetitionShowcaseSection />
      <DesignNotebooksSection />
      <PhotographyGallerySection />
      <ImpactTimelineSection />
    </div>
  );
};

export default Robotics;
